import React, { Component } from "react";
import { Row, Col, Container } from "styled-bootstrap-grid";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { dateFormat } from "../../../../../Api/Utils/ReuseableFunctions";
import Calendar from "../../calendar.png";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import { withRouter } from "react-router-dom";
import {
  updateManagerHoliday,
  addManagerHoliday
} from "../../../../../Actions";
import { format } from "date-fns";
class AddBranchClosure extends Component {
  constructor(props) {
    super(props);
    let holidayFormData = props.editHoliday ? props.editHoliday : null;
    this.state = {
      holidayStartDate: holidayFormData
        ? holidayFormData.holidayStartDate
          ? dateFormat(holidayFormData.holidayStartDate)
          : new Date()
        : new Date(),
      holidayEndDate: holidayFormData
        ? holidayFormData.holidayEndDate
          ? dateFormat(holidayFormData.holidayEndDate)
          : new Date()
        : new Date(),
      formData: {
        branchNr: holidayFormData
          ? holidayFormData.branchNr
          : props.userDefault.branchId,
        holidayName: holidayFormData ? holidayFormData.holidayName : "",
        holidayNr: holidayFormData ? holidayFormData.holidayNr : null,
        holidayEndDate: holidayFormData
          ? holidayFormData.holidayEndDate
            ? dateFormat(holidayFormData.holidayEndDate)
            : new Date()
          : new Date(),

        holidayStartDate: holidayFormData
          ? holidayFormData.holidayStartDate
            ? dateFormat(holidayFormData.holidayStartDate)
            : new Date()
          : new Date()
      }
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(date, name) {
    let formData = this.state.formData;
    if (name !== "holidayName") {
      formData[name] = date;
      formData["holidayEndDate"] = date;
      this.setState({ holidayEndDate: date });
    } else {
      formData[name] = date;
    }
    this.setState({
      formData,
      [name]: date
    });
  }

  saveHoliday = () => {
    let payload = {};
    if (this.props.editHoliday !== void 0) {
      payload = Object.assign(this.props.editHoliday, this.state.formData);
      payload.holidayStartDate = format(payload.holidayStartDate, "dd/MM/yyy");
      payload.holidayEndDate = format(payload.holidayEndDate, "dd/MM/yyy");
      this.props.dispatch(updateManagerHoliday(payload));
    } else {
      payload = this.state.formData;
      payload.holidayStartDate = format(payload.holidayStartDate, "dd/MM/yyy");
      payload.holidayEndDate = format(payload.holidayEndDate, "dd/MM/yyy");
      this.props.dispatch(addManagerHoliday(payload));
    }

    this.props.onClose();
  };
  render() {
    const { t } = this.props;
    const { onClose } = this.props;

    return (
      <MainDiv>
        <ContainerDiv>
          <Row>
            <Col sm="4">
              <SpanDivDes>
                <Trans>description</Trans>
              </SpanDivDes>
              <Input
                value={this.state.formData.holidayName}
                placeholder={t("description")}
                onChange={e => {
                  this.handleChange(e.target.value, "holidayName");
                }}
              />
            </Col>
            <Col sm="4">
              <SpanDiv>
                <Trans>startDate</Trans>
              </SpanDiv>
              <Datepicker
                customInput={
                  <div className="DateValue">
                    {" "}
                    {format(this.state.holidayStartDate, "d MMM yyyy")}{" "}
                  </div>
                }
                dateFormat="d MMM yyyy"
                selected={this.state.holidayStartDate}
                onChange={data => {
                  this.handleChange(data, "holidayStartDate");
                }}
                minDate={new Date()}
              />
              <ImageSpan>
                <Img src={Calendar} alt="Calendar" />
              </ImageSpan>
            </Col>
            <Col sm="4">
              <SpanDiv>
                <Trans>endDate</Trans>
              </SpanDiv>

              <Datepicker
                customInput={
                  <div className="DateValue">
                    {" "}
                    {format(this.state.holidayEndDate, "d MMM yyyy")}{" "}
                  </div>
                }
                dateFormat="d MMM yyyy"
                selected={this.state.holidayEndDate}
                onChange={data => {
                  this.handleChange(data, "holidayEndDate");
                }}
                minDate={this.state.holidayStartDate}
              />
              <ImageSpan>
                <Img src={Calendar} alt="Calendar" />
              </ImageSpan>
            </Col>
          </Row>
          <FooterData>
            <BtnCancel onClick={onClose}>
              <Trans>cancel</Trans>
            </BtnCancel>
            <BtnSave
              onClick={this.saveHoliday}
              disabled={!(this.state.formData.holidayName.length > 2)}
            >
              <Trans>save</Trans>
            </BtnSave>
          </FooterData>
        </ContainerDiv>
      </MainDiv>
    );
  }
}

const mapStateToProps = ({ auth, userMessage }) => {

  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    message: userMessage,
    userName: auth.appData.empName,
    userDefault: auth.user.defaultProfile
  };
};
export default withRouter(
  connect(mapStateToProps)(withTranslation()(AddBranchClosure))
);

const Datepicker = styled(DatePicker)`
  text-align: left;
  width: 120px;
  border: 1px solid #b2b7be;
  background: white;
  height: 28px;
  padding: 5px 10px 5px;
`;
const MainDiv = styled.div`
  font-family: Trebuchet MS;
  background: #f1f4f9;
  border-top: 1px solid #adb5bd;
  color: #4a4a4a;
  width: 103%;
  margin-left: -20px;
`;
const ContainerDiv = styled(Container)`
  width: 70%;
  float: center;
  padding-top: 1%;
`;
const Input = styled.input`
  position: relative;
  border: none;
  border-bottom: 1px solid #6c757d7a;
  background: #ffffff;
  width: 70%;
  outline: none;
  font-size: 16px;
  background: #f1f4f9;
  overflow-y: scroll;
  height: 29px;
`;
const SpanDiv = styled.div`
  font-size: 13px;
  text-align: left;
  padding-left: 29%;
  padding-bottom: 4px;
`;
const SpanDivDes = styled.div`
  padding-right: 50%;
`;
const ImageSpan = styled.span`
  position: relative;
  bottom: 0px;
  right: 10%;
`;
const Img = styled.img`
  height: 15px;
`;
const FooterData = styled.div`
  background: #f1f4f9;
  padding-top: 20px;
  text-align: center;

  right: 0px;
  width: 101%;
  margin-left: 4px;
`;
const BtnSave = styled.button`
  border: 1px solid #95989a;
  width: 130px;
  height: 35px;
  border-radius: 50px;
  margin-right: 10px;
  color: #434f5b;
  font-size: 12px;
  color: #ffffff;
  background: #c4151c;
`;
const BtnCancel = styled.button`
  background: #ffffff;
  border: 1px solid #95989a;
  width: 130px;
  height: 35px;
  border-radius: 50px;
  margin-right: 10px;
  color: #434f5b;
  font-size: 12px;
`;
